import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dtg_form_login = _resolveComponent("dtg-form-login")!
  const _component_dtg_link = _resolveComponent("dtg-link")!
  const _component_dtg_layout_auth = _resolveComponent("dtg-layout-auth")!

  return (_openBlock(), _createBlock(_component_dtg_layout_auth, null, {
    title: _withCtx(() => [
      _createTextVNode(" Connexion ")
    ]),
    footer: _withCtx(() => [
      _createTextVNode(" Vous avez oublié votre mot de passe?"),
      _hoisted_1,
      _createTextVNode(" Pour le réinitialiser "),
      _createVNode(_component_dtg_link, {
        href: _ctx.passwordResetHref,
        routed: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" cliquez ici ")
        ]),
        _: 1
      }, 8, ["href"]),
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_dtg_link, {
        href: _ctx.aboutHref,
        routed: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" A propos de MyDTG ")
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_dtg_form_login, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form) = $event)),
        "field-errors": _ctx.fieldErrors,
        submitting: _ctx.submitting,
        onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit($event)))
      }, null, 8, ["modelValue", "field-errors", "submitting"])
    ]),
    _: 1
  }))
}